export const TEMPLATE_BASE =
  "/orbia-ai-agency-technology-html-template-2026-08-14-02-54-53-utc/orbia";
export const ASSETS = `${TEMPLATE_BASE}/assets`;
export const IMG = `${ASSETS}/images/home-one`;
export const FOOTER_IMG = `${ASSETS}/images/footer`;
